import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { updateAgency } from 'services';
import { usePasswordConfirm } from 'helpers';
import { useCreateDispatches } from 'helpers/hooks';
import FormToggleSwitch from 'components/UtilityComponents/Form/FormToggleSwitch';

const TwoFactorToggle = () => {
	const agencyAgency = useSelector((state) => state.user.agency);
	const onPasswordConfirm = usePasswordConfirm();
	const { setLoader, setSnackbar } = useCreateDispatches();
	const [enforce2fa, setEnforce2fa] = useState(
		agencyAgency ? agencyAgency.enforce2FA : false
	);

	useEffect(() => {
		setEnforce2fa(agencyAgency?.enforce2FA);
	}, [agencyAgency]);

	const handleSwitch = () => {
		setLoader(true);
		const reqBody = {
			id: agencyAgency.id,
			enforce2FA: !enforce2fa,
		};
		updateAgency(reqBody)
			.then(() => {
				setSnackbar({
					variant: 'success',
					message: 'Successfully updated agency 2fa',
				});
			})
			.catch((e) => {
				setSnackbar({
					variant: 'error',
					message: 'There was a problem updating agency information',
				});
			});

		setLoader(false);
	};

	return (
		<FormToggleSwitch
			switchState={enforce2fa}
			setSwitch={() => onPasswordConfirm((e) => handleSwitch(e))}>
			Enforce Two Factor Authentication
		</FormToggleSwitch>
	);
};

export default TwoFactorToggle;
